import { render, staticRenderFns } from "./referral-create.vue?vue&type=template&id=5ad06bd6&scoped=true&"
import script from "./referral-create.vue?vue&type=script&lang=js&"
export * from "./referral-create.vue?vue&type=script&lang=js&"
import style0 from "./referral-create.vue?vue&type=style&index=0&id=5ad06bd6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad06bd6",
  null
  
)

export default component.exports